import { render, staticRenderFns } from "./OutageHeader.vue?vue&type=template&id=1b49de96&scoped=true&"
import script from "./OutageHeader.vue?vue&type=script&lang=js&"
export * from "./OutageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49de96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b49de96')) {
      api.createRecord('1b49de96', component.options)
    } else {
      api.reload('1b49de96', component.options)
    }
    module.hot.accept("./OutageHeader.vue?vue&type=template&id=1b49de96&scoped=true&", function () {
      api.rerender('1b49de96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/outagecenter/OutageHeader.vue"
export default component.exports